// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vtJ6","col":"styles_col__2p6mC","actions":"styles_actions__1skgK","conflict":"styles_conflict__3sQ75"};